import { render } from "./WCSideBar.vue?vue&type=template&id=04f14e07&scoped=true"
import script from "./WCSideBar.vue?vue&type=script&lang=js"
export * from "./WCSideBar.vue?vue&type=script&lang=js"

import "./WCSideBar.vue?vue&type=style&index=0&id=04f14e07&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f14e07"]])

export default __exports__